module.exports = __webpack_public_path__ + "img/OopsRight.7ce5ae80.svg";